module.exports = __webpack_public_path__ + "static/media/icon-americanexpress-24px.c2813452.svg";